import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Loader({ fullPage = false, text = 'Laddar…' }) {
  const content = (
    <Stack direction="column" alignItems="center" spacing={1}>
      <CircularProgress />
      {text && (
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
      )}
    </Stack>
  );

  if (fullPage) {
    return (
      <Box minHeight="60vh" display="flex" alignItems="center" justifyContent="center">
        {content}
      </Box>
    );
  }

  return content;
}
